import "./../../bindings/bao-tabs";
import "./../../bindings/foreach-selection";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-number-box";
import "./../../bindings/visibility";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SearchPaging from "./../../factories/search-paging";
import BaoDialog from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import FinitoService from "./../../services/finito-service";
function TransferDefinitionViewModel(tabPage) {
    var self = this;
    SearchPaging.call(self, tabPage);
    self.TabPage = tabPage;
    self.FormName = ko.observable();
    self.ShowForwardDays = ko.observable(false);
    self.ShowCopy = ko.observable(false);
    self.ShowState = ko.observable(false);
    self.ShowOptionsRow = ko.observable(false);
    self.CopyRadio = ko.observable("copy");
    self.CopyRadio.subscribe(function (newValue) {
        self.Copy(newValue == "copy");
    });
    self.Copy = ko.observable(true);
    self.Copy.subscribe(function (newValue) {
        if (newValue) {
            self.CopyRadio("copy");
        }
        else {
            self.CopyRadio("link");
        }
    });
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.OrgUnitSourceId()) ||
            Bao.Utils.String.IsNullOrEmpty(self.OrgUnitTargetId()) ||
            Bao.Utils.String.IsNullOrEmpty(self.ValidFromHtml()) ||
            Bao.Utils.String.IsNullOrEmpty(self.ValidToHtml())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.loaded = function () {
        this.InitPaging();
        this.TabPage.DirtyFlag.reset();
        this.TabPage.IsLoading(false);
        this.Focus();
        self.OrgUnitSourceId.subscribe(function (orgUnitSourceId) {
            self.toggleDaysForward();
        });
        self.OrgUnitTargetId.subscribe(function (orgUnitTargetId) {
            self.toggleDaysForward();
        });
        self.Automatic.subscribe(function () {
            self.toggleDaysForward();
        });
        self.toggleDaysForward();
    };
    self.toggleDaysForward = function () {
        var orgUnitSourceId = self.OrgUnitSourceId.peek(), orgUnitTargetId = self.OrgUnitTargetId.peek(), automatic = self.Automatic.peek();
        var sourceReportTypeId = ko.utils.arrayFirst(self.Report(), function (item: any) {
            return item.OrgUnitId() === orgUnitSourceId;
        }).ReportTypeId();
        var targetReportTypeId = ko.utils.arrayFirst(self.Report(), function (item: any) {
            return item.OrgUnitId() === orgUnitTargetId;
        }).ReportTypeId();
        //
        // automatischer Transfer bei Berichtsabschluss
        if (targetReportTypeId == FinitoService.ReportTypeIds.ShiftReport && sourceReportTypeId == FinitoService.ReportTypeIds.ShiftReport && automatic) {
            self.ShowOptionsRow(true);
            self.ShowForwardDays(true);
            self.ShowState(false);
            //self.Copy(true);
            self.State(true);
        }
        //
        // manueller Transfer
        else if (targetReportTypeId == FinitoService.ReportTypeIds.ShiftReport && sourceReportTypeId == FinitoService.ReportTypeIds.ShiftReport && !automatic) {
            self.ShowOptionsRow(true);
            self.ShowForwardDays(false);
            self.Copy(true);
            self.ShowState(true);
            self.State(false);
        }
        //
        // automatischer Transfer in Sammelbericht
        else if (sourceReportTypeId == FinitoService.ReportTypeIds.ShiftReport && targetReportTypeId == FinitoService.ReportTypeIds.SummaryReport) {
            self.ShowOptionsRow(false);
            self.Automatic(true);
            self.Copy(false);
            self.ShowState(true);
        }
        else {
            self.ShowOptionsRow(false);
            self.ShowState(false);
            self.Automatic(false);
            self.Copy(false);
            self.State(false);
        }
    };
}
;
Bao.inherit(TransferDefinitionViewModel, SearchPaging);
TransferDefinitionViewModel.prototype.PrimaryKey = "TransferConfigId";
TransferDefinitionViewModel.prototype.RefreshUrl = "MasterData/TransferDefinition/GetExtended";
TransferDefinitionViewModel.prototype.SaveUrl = "MasterData/TransferDefinition/Save";
TransferDefinitionViewModel.prototype.DeleteUrl = "MasterData/TransferDefinition/Delete";
TransferDefinitionViewModel.prototype.IsInUseUrl = "MasterData/TransferDefinition/IsInUse";
TransferDefinitionViewModel.prototype.PermissionForward = "TransferDefinitionForward";
TransferDefinitionViewModel.prototype.PermissionBackward = "TransferDefinitionBackward";
TransferDefinitionViewModel.prototype.PermissionSave = "TransferDefinitionSave";
TransferDefinitionViewModel.prototype.PermissionRefresh = "TransferDefinitionRefresh";
TransferDefinitionViewModel.prototype.PermissionDelete = "TransferDefinitionDelete";
export default TransferDefinitionViewModel;